module.exports = __webpack_public_path__ + "media/payment_networks/paypal-933f4459.png";